var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconFileDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.0835 8.49169H14.6752C12.7002 8.49169 11.0918 6.88335 11.0918 4.90835V2.50002C11.0918 2.04169 10.7168 1.66669 10.2585 1.66669H6.72516C4.1585 1.66669 2.0835 3.33335 2.0835 6.30835V13.6917C2.0835 16.6667 4.1585 18.3334 6.72516 18.3334H13.2752C15.8418 18.3334 17.9168 16.6667 17.9168 13.6917V9.32502C17.9168 8.86669 17.5418 8.49169 17.0835 8.49169Z",
    fill: "#A9B1C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 1.84164C12.8251 1.49997 12.2334 1.73331 12.2334 2.20831V5.11664C12.2334 6.33331 13.2667 7.34164 14.5251 7.34164C15.3167 7.34997 16.4167 7.34997 17.3584 7.34997C17.8334 7.34997 18.0834 6.79164 17.7501 6.45831C16.5501 5.24997 14.4001 3.07497 13.1667 1.84164Z",
    fill: "#A9B1C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconFileDefault);
export default __webpack_public_path__ + "static/media/common_icon_file_default.487bd2f10a1f700514e581d923dbad27.svg";
export { ForwardRef as ReactComponent };